import React from 'react';
import { useSelector } from 'react-redux';

import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { getMapViewState } from '../../selectors/mapSelectors';
import TravelTimeAccordion from './TravelTimeAccordion';
import TravelTimeBar from './TravelTimeBar';
import { MapViewState } from '../../utils';

export const TravelTimeDesktop: React.FC = () => {
  const { md } = useMediaQuery();
  const mapViewState = useSelector(getMapViewState);

  return md ? (
    mapViewState === MapViewState.fullMap ? (
      <TravelTimeBar />
    ) : (
      <TravelTimeAccordion />
    )
  ) : null;
};

export default TravelTimeDesktop;
